import AssociatesDashboard from "./_components/AssociatesDashboard";

export default function HomeAssociatesPage() {
  return <AssociatesDashboard />;
}
